import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import * as _ from "../util/lodash";
import PropTypes from "prop-types";
var IGNORE_REQUIRED_SECRET_KEY = "IGNORE_REQUIRED_SECRET_KEY"; // custom prop to check regex props - so you can pass a regular expression as a prop

function regexpChecker(props, propName, componentName) {
  var _componentName = componentName || "ANONYMOUS";

  if (props[propName]) {
    return props[propName] instanceof RegExp ? null : new Error(propName + " in " + _componentName + " is not a valid regular expression");
  } // assume all ok


  return null;
}

function decorateNoParameterTypeChecker(validate) {
  var preCheck, chainedCheck;

  preCheck = function preCheck(isRequired, defaultProps) {
    return check(validate, isRequired, defaultProps);
  };

  chainedCheck = _bindInstanceProperty(preCheck).call(preCheck, null, false);
  chainedCheck.isRequired = _bindInstanceProperty(preCheck).call(preCheck, null, true);
  return chainedCheck;
} // These PropTypes take an additional parameter of potential options


function decorateWithParameterSimpleTypeChecker(validate) {
  var preCheck, chainedCheck;
  return function (options) {
    var _validate = validate(options);

    preCheck = function preCheck(isRequired, defaultProps) {
      return check(_validate, isRequired, defaultProps);
    };

    chainedCheck = _bindInstanceProperty(preCheck).call(preCheck, null, false);
    chainedCheck.isRequired = _bindInstanceProperty(preCheck).call(preCheck, null, true);
    return chainedCheck;
  };
}

function decorateWithParameterComplexTypeChecker(validate) {
  var preCheck, chainedCheck, _options;

  return function (options) {
    // These options are additional PropTypes
    // We need to call them to simulate the defaultProps that would get passed in by the component factory
    // We use this secret key to bypass the requirement for default props.
    // oneOfType
    if (_.isArray(options)) {
      _options = _mapInstanceProperty(_).call(_, options, function (option) {
        return option(IGNORE_REQUIRED_SECRET_KEY);
      }); // arrayOf, objectOf
    } else if (_.isFunction(options)) {
      _options = options(IGNORE_REQUIRED_SECRET_KEY); // shape
    } else {
      _options = _mapInstanceProperty(_).call(_, options, function (option) {
        return option(IGNORE_REQUIRED_SECRET_KEY);
      });
    }

    var _validate = validate(_options);

    preCheck = function preCheck(isRequired, defaultProps) {
      return check(_validate, isRequired, defaultProps);
    };

    chainedCheck = _bindInstanceProperty(preCheck).call(preCheck, null, false);
    chainedCheck.isRequired = _bindInstanceProperty(preCheck).call(preCheck, null, true);
    return chainedCheck;
  };
}

function check(validate, isRequired, defaultProps) {
  return function (props, propName, componentName, location) {
    if (!isRequired && !!defaultProps && !defaultProps.hasOwnProperty(propName) && defaultProps !== IGNORE_REQUIRED_SECRET_KEY) {
      return new Error("Optional " + location + " `" + propName + "` did not specify a default value.");
    } else if (props[propName] == null) {
      if (isRequired) {
        return new Error("Required " + location + " `" + propName + "` was not specified in " + ("`" + componentName + "`."));
      }

      return null;
    } else {
      var _context;

      for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
        rest[_key - 4] = arguments[_key];
      }

      return validate.apply(void 0, _concatInstanceProperty(_context = [props, propName, componentName, location]).call(_context, rest));
    }
  };
}

var propTypes = {
  array: decorateNoParameterTypeChecker(PropTypes.array),
  bool: decorateNoParameterTypeChecker(PropTypes.bool),
  func: decorateNoParameterTypeChecker(PropTypes.func),
  number: decorateNoParameterTypeChecker(PropTypes.number),
  object: decorateNoParameterTypeChecker(PropTypes.object),
  string: decorateNoParameterTypeChecker(PropTypes.string),
  symbol: decorateNoParameterTypeChecker(PropTypes.symbol),
  any: decorateNoParameterTypeChecker(PropTypes.any),
  element: decorateNoParameterTypeChecker(PropTypes.element),
  node: decorateNoParameterTypeChecker(PropTypes.node),
  regexp: decorateNoParameterTypeChecker(regexpChecker),
  oneOf: decorateWithParameterSimpleTypeChecker(PropTypes.oneOf),
  instanceOf: decorateWithParameterSimpleTypeChecker(PropTypes.instanceOf),
  arrayOf: decorateWithParameterComplexTypeChecker(PropTypes.arrayOf),
  objectOf: decorateWithParameterComplexTypeChecker(PropTypes.objectOf),
  // Currently shape does not supported nested definitions of any complexTypeChecker
  shape: decorateWithParameterComplexTypeChecker(PropTypes.shape),
  oneOfType: decorateWithParameterComplexTypeChecker(PropTypes.oneOfType)
};
export default propTypes;
//# sourceMappingURL=prop-types.js.map